<ng-container *ngIf="mailUsuario">
  <iframe [src]="urlSafe" width="" height=""></iframe>
</ng-container>
